module.exports = new __parcel__URL__("sprite.02b3eaa4.svg").toString();